import { render, staticRenderFns } from "./PassengerGroupPassengers.vue?vue&type=template&id=98ef5148&scoped=true"
import script from "./PassengerGroupPassengers.vue?vue&type=script&lang=ts"
export * from "./PassengerGroupPassengers.vue?vue&type=script&lang=ts"
import style0 from "./PassengerGroupPassengers.vue?vue&type=style&index=0&id=98ef5148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ef5148",
  null
  
)

export default component.exports